import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    selected: 'shopping', // Current state of the application here
    contentId: '',
    broadCastXAuthId: '',
    broadCastProductList: [],
    broadCastProductListLive: null,
    liveUserList: [],
    netOff: false,
    noLive: false
  },

  getters: {
    selected: state => state.selected,
    contentId: state => state.contentId,
    broadCastXAuthId: state => state.broadCastXAuthId,
    broadCastProductList: state => state.broadCastProductList,
    broadCastProductListLive: state => state.broadCastProductListLive,
    liveUserList: state => state.liveUserList,
    noLive: state => state.noLive,
    netOff: state => state.netOff
  },

  mutations: {
    updateSelected(state, data) {
      state.selected = data.selected
    },
    contentId(state, data) {
      state.contentId = data.contentId
    },
    broadCastXAuthId(state, data) {
      state.broadCastXAuthId = data.broadCastXAuthId
    },
    broadCastProductList(state, data) {
      state.broadCastProductList = data
    },
    broadCastProductListLive(state, data) {
      state.broadCastProductListLive = data
    },
    liveUserList(state, data) {
      state.liveUserList = data
    },
    noLive(state, data) {
      state.noLive = data
    },
    netOff(state, data) {
      state.netOff = data
    }
  }
})
export default store
